import React from 'react'
import { useTheme } from '@mui/material/styles'
import SettingsIcon from '@mui/icons-material/Settings'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'

const ButtonConfigModal = ({ onClick, storedData, disabled, withLabel, largeLabel }: any) => {
    const theme = useTheme()

    const color = !storedData || !storedData.cpsCard || !storedData.pin ? theme.palette.error.main : 'initial'

    if (withLabel) {
        return (
            <Button
                aria-label="info"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={onClick}
                disabled={disabled}
                color="inherit"
                style={{
                    color,
                }}
                startIcon={<SettingsIcon titleAccess="Configuration" />}
            >
                {largeLabel ? 'Configuration des lecteurs de cartes' : 'Configuration'}
            </Button>
        )
    }

    return (
        <IconButton
            aria-label="info"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={onClick}
            color="primary"
            edge="start"
            disabled={disabled}
            style={{
                color,
            }}
            size="large"
        >
            <SettingsIcon titleAccess="Configuration" />
        </IconButton>
    )
}

export default ButtonConfigModal
